import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Card, Col, Row, Button } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PropTypes from "prop-types";
import * as propertyActions from "../../../../../actionCreators/Property";
import * as zonesActions from "../../../../../actionCreators/Zones";
import * as taxCollectionActions from "../../../../../actionCreators/TaxCollection";
import useDebounce from "../../../../../customHooks/useDebounce";
import Logo from "../../../../../assets/Logo.png";
import "../../reports/reports.css";

import PieChart from "../../graph-plots/pie";
import BarChart from "../../graph-plots/bar";
import {
  formatUnitsOfProperties,
  formatYearlyTotalAndPaidTax,
  customColorFunction,
  formatLabelFunction,
  tooltipFormatterFunction,
} from "../../../../../utils/reportsUtils";
import { getFiscalYear } from "../../../../../utils/dateTime";

const Overview = (props) => {
  const isAdmin = (user) => user?.data?.user_roles[0]?.role?.role === "Admin";
  const history = useHistory();
  const { id } = useParams();
  const [total, setTotal] = useState(0);
  const [demandCurrentFiscalYear, setDemandCurrentFiscalYear] = useState("");
  const [yearlyPaidAndPendingTaxData, setYearlyPaidAndPendingTaxData] =
    useState([]);
  const [yearlyPaidAndPendingUnits, setYearlyPaidAndPendingUnits] = useState(
    []
  );

  useEffect(() => {
    if (isAdmin(props?.currentUser)) {
      const obj = { districtId: id };
      props.getRegisteredPropertiesPercentagesByZone(obj);
      props.getYearlyPaidAndTotalTax(obj);
      props.getYearlyPaidAndPendingUnits(obj);
      if (props?.etoZones?.data?.length === 0) {
        props.getZones(obj);
      }
    } else {
      props.getRegisteredPropertiesPercentagesByZone();
      props.getZones();
      props.getYearlyPaidAndTotalTax();
      props.getYearlyPaidAndPendingUnits();
    }
  }, [props.currentUser]);
  useEffect(() => {
    if (total === 0) {
      props.registeredPropertiesPercentagesByZone?.data?.map((count) => {
        setTotal(total + count.propertyCount);
      });
    }
  }, [props.registeredPropertiesPercentagesByZone?.data]);
  useEffect(() => {
    const [data] = formatYearlyTotalAndPaidTax(
      props.yearlyTotalAndPaidTax.data,
      null
    );
    setYearlyPaidAndPendingTaxData(data);
    const currentYear = getFiscalYear();
    const totalTaxCurrentYear = props?.yearlyTotalAndPaidTax?.data?.filter(
      (item) => +item?.taxyear === currentYear
    )[0]?.total_tax;
    setDemandCurrentFiscalYear(totalTaxCurrentYear);
  }, [props.yearlyTotalAndPaidTax]);
  useEffect(() => {
    const [data] = formatUnitsOfProperties(
      props?.yearlyPaidAndPendingUnits?.data,
      null
    );
    setYearlyPaidAndPendingUnits(data);
  }, [props.yearlyPaidAndPendingUnits]);
  useDebounce(
    () => {
      if (
        demandCurrentFiscalYear &&
        demandCurrentFiscalYear != "" &&
        yearlyPaidAndPendingTaxData.length > 0 &&
        yearlyPaidAndPendingUnits.length > 0 &&
        props.registeredPropertiesPercentagesByZone.data &&
        props.registeredPropertiesPercentagesByZone.data.length > 0
      ) {
        const input = document.getElementById("report");
        html2canvas(input).then((canvas) => {
          var imgWidth = 200;
          var pageHeight = 290;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          var position = 0;
          var heightLeft = imgHeight;
          pdf.addImage(imgData, "JPEG", 7, position, imgWidth, imgHeight);
          // pdf.save("download1.pdf");
          window.open(pdf.output("bloburl"), "_blank");
        });
      }
    },
    [
      demandCurrentFiscalYear,
      yearlyPaidAndPendingTaxData,
      yearlyPaidAndPendingUnits,
      props.registeredPropertiesPercentagesByZone,
    ],
    3000
  );

  return (
    <div style={{ background: "white" }}>
      <div className="close-button-section">
        <Button
          className="close-button"
          // type="primary"
          onClick={() => {
            history.goBack();
          }}
        >
          <ArrowLeftOutlined />
          <span>Back</span>
        </Button>
      </div>
      <div id="report">
        <div className="report-logo">
          <img src={Logo}></img>
          <div className="text-data">Report Overview</div>
        </div>
        <div className="header-details">
          <Typography className="text-label">
            Date :{" "}
            <span className="text-data"> {new Date().toDateString()}</span>
          </Typography>
          <Typography className="text-label">
            District Name :{" "}
            <span className="text-data">
              {" "}
              {props?.etoZones?.data[0]?.district?.name}
            </span>
          </Typography>
          <Typography className="text-label">
            ETO Name(s) :{" "}
            <span className="text-data">
              {" "}
              {props?.etoZones?.data?.map((etoZone)=>{return etoZone?.user_role?.user?.full_name}).join(", ")}
            </span>
          </Typography>
        </div>
        <div>
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card
                  className="report-stats-header"
                  bordered={false}
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    TOTAL REGISTERED PROPERTIES
                  </Typography>
                  <Typography className="report-stats-data">{total}</Typography>
                  <PieChart
                    data={props.registeredPropertiesPercentagesByZone.data}
                    angleField="propertyCount"
                    colorField="zone"
                  />
                </Card>
                <br />
                <div
                  className="report-stats-container"
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    TOTAL DEMAND CURRENT FISCAL YEAR
                  </Typography>
                  <div className="report-stats-data">
                    PKR{" "}
                    {demandCurrentFiscalYear
                      ? parseInt(demandCurrentFiscalYear)?.toLocaleString()
                      : 0}
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card bordered={false} style={{ border: "1px solid black" }}>
                  <BarChart
                    data={yearlyPaidAndPendingTaxData}
                    xField="year"
                    yField="tax"
                    xLabel="Fiscal Year"
                    yLabel="Tax (PKR)"
                    customColorFtn={customColorFunction}
                    colorFieldName={"name"}
                    formatLabelFunction={formatLabelFunction}
                    tooltipFormatterFunction={tooltipFormatterFunction}
                    isNoData={!props?.yearlyTotalAndPaidTax?.data?.length}
                  />
                </Card>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Card style={{ border: "1px solid black" }}>
                  <BarChart
                    data={yearlyPaidAndPendingUnits}
                    xField="year"
                    yField="units"
                    xLabel="Fiscal Year"
                    yLabel="Units (Properties)"
                    customColorFtn={customColorFunction}
                    colorFieldName={"name"}
                    formatLabelFunction={formatLabelFunction}
                    loading={props?.yearlyPaidAndPendingUnits?.loading}
                    isNoData={!props?.yearlyPaidAndPendingUnits?.data?.length}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  property: { registeredPropertiesPercentagesByZone },
  zones: { etoZones },
  taxCollection: { yearlyTotalAndPaidTax, yearlyPaidAndPendingUnits },
  user: { currentUser },
}) => ({
  registeredPropertiesPercentagesByZone,
  etoZones,
  yearlyTotalAndPaidTax,
  yearlyPaidAndPendingUnits,
  currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  getRegisteredPropertiesPercentagesByZone: bindActionCreators(
    propertyActions.getRegisteredPropertiesPercentagesByZone,
    dispatch
  ),
  getZones: bindActionCreators(zonesActions.getEtoZones, dispatch),
  getYearlyPaidAndTotalTax: bindActionCreators(
    taxCollectionActions.getYearlyTotalAndPaidTax,
    dispatch
  ),
  getYearlyPaidAndPendingUnits: bindActionCreators(
    taxCollectionActions.getYearlyPaidAndPendingUnits,
    dispatch
  ),
});

Overview.propTypes = {
  getRegisteredPropertiesPercentagesByZone: PropTypes.func.isRequired,
  getZones: PropTypes.func.isRequired,
  getYearlyPaidAndTotalTax: PropTypes.func.isRequired,
  getYearlyPaidAndPendingUnits: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
